import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { pages, pageTypes } from "..";
import { useMatchScreen } from "../../../App";
import styles from "../../../common/styles";
import { DP } from "../../../common/types";
import { ProfileContext } from "../../../context/profileContext";
import { useStateReducer } from "../../../hooks/useStateReducer";
import { getPostsStore, setPostsStore, setPostsStoreField } from "./Posts";

interface Props extends DP {}

const NavigateButtons = (props: Props) => {
  const [state, setState] = useStateReducer({ isOpened: false });
  const screenMdMatch = useMatchScreen("md");

	const {pathname} = useLocation()
	const {currentPage} = getPostsStore()
	const profile = useContext(ProfileContext)

  const handleDown = (e: React.PointerEvent<HTMLDivElement>) => {};
  const handleUp = (e: PointerEvent) => {};
  const handleMove = (e: PointerEvent) => {};

	const handleClick = (page: pageTypes) => () => {
		if (page != currentPage) {
			setPostsStore({
        posts: [],
        page: 0,
        isFetching: true,
				isLoading: true,
        currentPage: page,
      });
		}
	}

	useEffect(() => {
		const page = pages.find((p) => p.location() == pathname)
		if (page) {
			setPostsStore({currentPage: page.pageType})
		}
	}, [pathname])

  return (
    <Wrapper isOpened={state.isOpened} className={props.className}>
      {pages.map((el) => {
				if (el.pageType == 'subscribed' && !profile) return;
				return (
          <LinkButton
            to={"../" + el.location()}
            isCurrent={el.location() == pathname}
            onClick={handleClick(el.pageType)}
          >
            <el.icon />
            {screenMdMatch && <p>{el.title}</p>}
          </LinkButton>
        );
			})}
    </Wrapper>
  );
};

const Wrapper = styled.div(({ isOpened }: { isOpened: boolean }) => [
  tw``,
  tw`box-content overflow-hidden md:(w-auto overflow-visible)`,
  !isOpened && tw`w-[var(--icon-size)]`,
  styles.border,
  css`
    --icon-size: 1rem;

    border-style: solid solid solid none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    ${LinkButton} + ${LinkButton} {
      ${styles.border}
      border-style: solid none none none;
      border-radius: 0;
    }
  `,
]);

const LinkButton = styled(Link)(({isCurrent}: {isCurrent: boolean}) => [
  tw`flex py-1 grow whitespace-nowrap items-center text-[0.6rem] space-x-1 text-pink-600`,
  tw`px-0.5 md:(w-full px-3)`,
	isCurrent && tw`font-bold`,
  css`
    & svg {
      width: var(--icon-size);
      height: var(--icon-size);
    }
  `,
]);

export default styled(NavigateButtons)``;
